import { useTranslation } from "react-i18next";

import { ActionButtons } from "../Common/ActionButtons";
import { Container, Heading, LeftSide, RightSide } from "../Common";
import { GameKind } from "../../../../../../gql/graphql";
import { GamePreview, STEPS_TO_CONFIGURE_PROJECT } from "../../GamePreview";
import { QuickRankSettingsForm } from "./QuickRankSettingsForm";
import { RankifierSettingsForm } from "./RankifierSettingsForm";
import { SwiperSettingsForm } from "./SwiperSettingsForm";
import { TriviaGame } from "../../../../../../graphql/helpers/isTriviaGame";
import { TriviaSettingsForm } from "./TriviaSettingsForm";
import { useGame } from "../../../../../../contexts/game/GameContext";
import { WordopolisSettingsForm } from "./WordopolisSettingsForm";

import styles from "./GameSettings.module.scss";
import { WordleGame, WordleSettingsForm } from "./WordleSettingsForm";

export const GameSettings = () => {
  const { currentGame } = useGame();
  const { t } = useTranslation();

  if (!currentGame) {
    return null;
  }

  const gameForm = {
    [GameKind.Swiper]: <SwiperSettingsForm />,
    [GameKind.QuickRank]: <QuickRankSettingsForm game={currentGame} />,
    [GameKind.Rankifier]: <RankifierSettingsForm game={currentGame} />,
    [GameKind.Wordopolis]: <WordopolisSettingsForm game={currentGame} />,
    [GameKind.Trivia]: <TriviaSettingsForm game={currentGame as TriviaGame} />,
    [GameKind.Wordle]: <WordleSettingsForm game={currentGame as WordleGame} />,
  }[currentGame.kind];

  return (
    <Container>
      <RightSide>
        <GamePreview step={STEPS_TO_CONFIGURE_PROJECT.GAME_SETTINGS} />
      </RightSide>
      <LeftSide key={currentGame.id}>
        <Heading title={{ main: t("project:gameSettings.header1"), marked: t("project:gameSettings.header2") }}>
          {t("project:gameSettings.description")} <span className={styles.selectedGame}>{currentGame?.name}</span>
        </Heading>

        {gameForm}
        <ActionButtons />
      </LeftSide>
    </Container>
  );
};
